import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HighContrastService {
  private highContrastState = new BehaviorSubject<boolean>(false);

  getHighContrastState() {
    return this.highContrastState.asObservable();
  }

  setHighContrastState(value: boolean) {
    this.highContrastState.next(value);
  }
}
